import { PJAxios, usePJStore } from '@jaf/jaf-react-core';
import { AutoComplete } from 'primereact/autocomplete';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { ProgressSpinner } from 'primereact/progressspinner';
import React, { useEffect, useState } from 'react';
import { flushCache } from '../../../api/ChatbotApi';
import isFilled from '../../Utils';


function Dest(props) {

    const [name_it, setName_it] = useState("");
    const [name_en, setName_en] = useState("");
    const [email, setEmail] = useState("");

    const [modifiedNodes, setModifiedNodes] = useState([]);
    const [loading, setLoading] = useState(false);

    const [gruppo, setGruppo] = useState(null);
    const [gruppi, setGruppi] = useState(null);
    const [modifiedItems, setModifiedItems] = useState([]);



    const getText = usePJStore((state) => state.i18n_getText)
    const bundles = usePJStore((state) => state.i18n_bundles)
    
    const getTextByLang = (lang, key) => {
      return bundles?.[lang]?.[key]
    }
    const dbTest = usePJStore((state) => state.appInfo_dbTest);
    const { storage } = usePJStore((state) => state.storage)


    useEffect(() => {
        setGruppi(props.gruppi);
    }, []);

    useEffect(() => {

        if (props.selectedNode != null) {
            setName_it(getTextByLang("it",props.selectedNode.title));
            setName_en(getTextByLang("en",props.selectedNode.title));
            setEmail(props.selectedNode.email);
        }

        setTimeout(() => {
            props.onNodeLoaded();
        }, 500);

    }, [props.selectedNode]);

    const salvaDest = (request) => {
        setLoading(true);
        PJAxios().post('/gestioneConfigurazioni/createDest', request).then((res) => {
            onSave(props.tematica, true);
            setModifiedItems([]);
            flushCache(dbTest);
        }).finally(() => {
            setLoading(false)
        });

    }

    const searchGroup = (event) => {

        setTimeout(() => {
            var ret = [];
            gruppi.forEach((item) => {
                if (item.tag.toLowerCase().indexOf(event.query.toLowerCase()) !== -1) {

                    let question = {
                        tag: item.tag,
                        conteggio: item.conteggio
                    }

                    ret.push(question);
                }
            })

            setGruppi(ret);
        }, 250);

    }

    const salva = () => {

        if (props.isNew) {
            let request = {
                name_it,
                name_en,
                email,
                gruppo: gruppo.tag != null ? gruppo.tag : gruppo,
                idConfig: props.idConfig
            }
            salvaDest(request);

        } else {
            let modifiedItems = [];
            modifiedItems.push({ is_new: false, id_item: props.selectedNode.idItem, id_element: "email", op_type: "mod_el", obj_type: "itemDest", new_val: email });
            modifiedItems.push({ is_new: false, id_item: props.selectedNode.idItem, id_element: "nome_it", op_type: "mod_el", obj_type: "menu", new_val: name_it });
            modifiedItems.push({ is_new: false, id_item: props.selectedNode.idItem, id_element: "nome_en", op_type: "mod_el", obj_type: "menu", new_val: name_en });

            setModifiedNodes(modifiedItems);
        }

    }

    const onSave = (tematica, outcome) => {
        props.onSave(tematica, outcome);
    }

    const salvaTutto = () => {
        setLoading(true);
        PJAxios().post('/gestioneConfigurazioni/salvaTutto', { operazioni: modifiedNodes, idConfig: props.tematica.id_config }).then((res) => {
            onSave(props.tematica, true);
            setModifiedNodes([]);
            flushCache(dbTest);
        }).finally(() => {
            setLoading(false)
          });

    }

    const itemTemplate = (item) => {
        return (
            <div >
                <div className="formgroup-inline col-12 md:col-12">
                    <div>{item.tag}</div>
                </div>
            </div>
        )
    }

    useEffect((e) => {
        if (modifiedNodes.length > 0) {
            salvaTutto();
        }
    }, [modifiedNodes]);

    const confirmOperation = (event) => {
        props.onConfirmOperation(event)
    }

    const validateForm = () => {
        return isFilled(name_en) && isFilled(name_it) && isFilled(email)
    }
    
    return (
        <>
            {loading &&
                <ProgressSpinner />
            }

            {!loading &&
                <div className="p-fluid grid">
                    <div className="field col-12 md:col-12">
                        
                            <>
                                <div className="col-12 md:col-12">
                                    {getText("NOME_IT")}
                                    <InputText placeholder={getText("SCRIVI_QUALCOSA")} className="p-inputtext-sm block" id="name" value={name_it} onChange={(e) => setName_it(e.target.value)} />
                                </div>
                                <div className="col-12 md:col-12">
                                    {getText("NOME_EN")}
                                    <InputText placeholder={getText("SCRIVI_QUALCOSA")} id="name" className="p-inputtext-sm block " value={name_en} onChange={(e) => setName_en(e.target.value)} />
                                </div>
                                <div className=" col-12 md:col-12">
                                    {getText("PERSONAL_EMAIL_ADDRESS")}

                                </div>
                                <div className=" col-12 md:col-12">
                                    <InputTextarea rows={5} cols={80} value={email} onChange={(e) => setEmail(e.target.value)} />
                                </div>
                                <br />
                                {props.isNew &&

                                    <span className="p-fluid">
                                        <AutoComplete field="tag" dropdown placeholder={getText("INSERISCI_GRUPPO_PLACEHOLDER")} value={gruppo} suggestions={gruppi} completeMethod={searchGroup} onChange={(e) => setGruppo(e.value)} itemTemplate={itemTemplate} />
                                    </span>

                                }

                            </>
                            <div className="p-fluid grid">
                                <div className="field col-3 md:col-3">
                                    <Button disabled={!validateForm()} label={getText("SALVA")} size="large" className="p-button p-button-primary" onClick={salva} icon="pi pi-save" />
                                    
                                </div>
                                <br />
                                <div className="field col-3 md:col-3">
                                    {!props.isNew && <Button icon="pi pi-trash" className="p-button-primary" label={getText("ELIMINA")} onClick={confirmOperation} ></Button>}
                                </div>
                            </div>
                        
                    </div>
                </div>
            }
        </>
    )
}

export default Dest
